import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { CONTACT_WIZARD_SAMPLE } from "../consts";
import { getContactName, getInitials } from "../helpers";
import { ContactWizardSceneProps } from "../types";

/** Korak "Telefon": brojevi po vrsti s primarnim i poziv na primarni broj. */
const PhoneScene: React.FC<ContactWizardSceneProps> = ({ formValues }) => {
  const name = getContactName(formValues);
  const [primaryPhone] = CONTACT_WIZARD_SAMPLE.phones;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Telefoni</div>
          <div className="text-sm font-bold text-slate-800 truncate">{name}</div>
          <div className="mt-3 space-y-2">
            {CONTACT_WIZARD_SAMPLE.phones.map((phone) => (
              <div key={phone.value} className="rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-semibold text-slate-800 truncate">{phone.value}</span>
                  {phone.primary && (
                    <span className="px-1.5 py-0.5 rounded-full bg-emerald-100 text-[0.55rem] font-semibold text-emerald-700 flex-shrink-0">
                      Primarni
                    </span>
                  )}
                </div>
                <div className="text-[0.6rem] text-slate-400">{phone.type}</div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5 text-center">
          <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 text-xs font-bold text-white">
            {getInitials(name)}
          </span>
          <div className="mt-2 text-xs font-bold text-slate-800 truncate">{name}</div>
          <div className="text-[0.65rem] text-slate-400">{primaryPhone.value}</div>
          <div className="mt-3 inline-flex items-center justify-center w-8 h-8 rounded-full bg-emerald-500">
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.13.96.36 1.9.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0122 16.92z" />
            </svg>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Mobitel, fiksni ili fax"
          subtitle="Vrsta uz svaki broj"
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="5" y="2" width="14" height="20" rx="2" />
              <path d="M12 18h.01" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(PhoneScene);
